module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan3-2-81a05c8c50d1d395f0527e684100caa1.webp";